module.exports = __webpack_public_path__ + "static/img/购物车暂无icon@2x@2x.20988e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/购物车/购物车暂无icon@2x@2x.png
// module id = jD2I
// module chunks = 192